module.exports = __webpack_public_path__ + "img/rba_fantastique_juillet2021.2f190f13.jpg";